import AccountsReceivableSettlement from 'models/accounts-receivable-settlement'
import CurrencyMinxins from "common/mixins/currency";
export default {
  mixins: [CurrencyMinxins],
  data() {
    return {
      // 进仓单状态选择索引
      activeEnterWarehouseStatusIndex: 0,
      // 进仓单状态
      enterWarehouseStatus: null,
      enterWarehouseTableData: [],
      // 进仓单所有数据
      enterWarehouseCodeList: [],
      enterWarehouseCheckAll: false,
      // 选中的数据
      checkedEnterWarehouseCodeList: [],
      enterWarehouseIsIndeterminate: false,
      activeEnterWarehouseCode: '',
    }
  },
  created() {
  },
  methods: {
    // 进仓列表
    initEnterWarehouseTable() {
      let projectId = this.screen.projectId;
      let projectName = this.screen.projectName;
      let balanceBeginDate = this.screen.date ? this.screen.date[0] : '';
      let balanceEndDate = this.screen.date ? this.screen.date[1] : '';
      let currency = this.screen.currencySystem;
      let data = {
        projectId,
        projectName,
        balanceBeginDate,
        balanceEndDate,
        currency
      }
      AccountsReceivableSettlement.getEnterWarehouseList(data).then(res => {
        if (res.success) {
          let enterWarehouseCodeList = [];
          res.result.map(value => {
            let obj = {};
            obj.code = value.inboundOrderNo;
            obj.amount = value.amount
            obj.checked = false
            obj.subjectList = []
            value.feeList.map(j => {
              if (!j.orderFeeId) throw new Error(`费用明细缺少orderFeeId，进仓单号：${value.inboundOrderNo}，费用名称：${j.feeName}`)
              let obj2 = {}
              obj2.id = j.keyword;
              obj2.keyId = `${value.inboundOrderNo}-${j.orderFeeId}`;
              obj2.isSelect = false;
              obj2.feeName = j.feeName;
              obj2.isAddService = j.isAddService;
              obj2.orderFeeId = j.orderFeeId;
              obj2.agentBusiness = j.agentBusiness;
              obj2.agentBusinessVal = j.agentBusiness?'是':'否';
              obj2.billHeadId = j.billHeadId;
              obj2.billHeadName = j.billHead ? `${j.billHead.name} ${j.billHead.code}` : '';
              obj2.currency = j.currency;
              obj2.currencyVal = this.currencySystemObj[j.currency];
              obj2.amount = j.price;
              obj2.status = j.isBalance?2:1;
              obj2.statusVal = !j.isBalance? '未结算' : '已结算';
              obj.subjectList.push(obj2)
            })
            enterWarehouseCodeList.push(obj);
          });
          this.enterWarehouseCodeList = enterWarehouseCodeList
          this.enterWarehouseIsIndeterminate = false;
          this.enterWarehouseTableData = []
          this.checkedEnterWarehouseCodeList = []
          this.initTotalAccountsReceivable()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 应付进仓列表
    initPayEnterWarehouseTable() {
      let projectId = this.screen.projectId;
      let billHeadId = this.screen.lookUpId;
      let balanceBeginDate = this.screen.date ? this.screen.date[0] : '';
      let balanceEndDate = this.screen.date ? this.screen.date[1] : '';
      let currency = this.screen.currencySystem;
      let data = {
        projectId,
        billHeadId,
        balanceBeginDate,
        balanceEndDate,
        currency
      }
      AccountsReceivableSettlement.getPayEnterWarehouseList(data).then(res => {
        if (res.success) {
          let enterWarehouseCodeList = [];
          res.result.map(value => {
            let obj = {};
            obj.code = value.inboundOrderNo;
            obj.amount = value.amount
            obj.checked = false
            obj.subjectList = []
            value.feeList.map(j => {
              if (!j.orderFeeId) throw new Error(`费用明细缺少orderFeeId，进仓单号：${value.inboundOrderNo}，费用名称：${j.feeName}`)
              let obj2 = {}
              obj2.id = j.keyword;
              obj2.keyId = `${value.inboundOrderNo}-${j.orderFeeId}`;
              obj2.isSelect = false;
              obj2.feeName = j.feeName;
              obj2.projectId = j.projectId;
              obj2.projectName = j.projectName;
              obj2.isAddService = j.isAddService;
              obj2.orderFeeId = j.orderFeeId;
              obj2.agentBusiness = j.agentBusiness;
              obj2.agentBusinessVal = j.agentBusiness?'是':'否';
              obj2.billHeadId = j.billHeadId;
              obj2.billHeadName = j.billHead ? `${j.billHead.name} ${j.billHead.code}` : '';
              obj2.currency = j.currency;
              obj2.currencyVal = this.currencySystemObj[j.currency];
              obj2.amount = j.price;
              obj2.status = j.isBalance?2:1;
              obj2.statusVal = !j.isBalance? '未结算' : '已结算';
              obj.subjectList.push(obj2)
            })
            enterWarehouseCodeList.push(obj);
          });
          this.enterWarehouseCodeList = enterWarehouseCodeList
          this.enterWarehouseIsIndeterminate = false;
          this.enterWarehouseTableData = []
          this.checkedEnterWarehouseCodeList = []
          this.initTotalAccountsReceivable()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 初始化进仓数据
    initEntryData() {
      this.activeEnterWarehouseStatusIndex = 0
      this.enterWarehouseStatus = null
      this.enterWarehouseTableData = []
      this.enterWarehouseCodeList = []
      this.enterWarehouseCheckAll = false
      this.checkedEnterWarehouseCodeList = []
      this.enterWarehouseIsIndeterminate = false
      this.activeEnterWarehouseCode = ''
    },
    changeEnterWarehouseCode(row) {
      row.checked = !row.checked
      this.activeEnterWarehouseCode = row.code
      row.subjectList.map(i => {
        if (i.status !== 2) i.isSelect = row.checked
      })
      this.enterWarehouseTableData = row.checked?row.subjectList:[]
      if (!row.checked) {
        this.$nextTick(() => {
          this.$refs.enterWarehouseMultipleTable.clearSelection();
        })
      }
      this.enterWarehouseTableData.map(i => {
        if (i.isSelect) {
          this.$nextTick(() => {
            this.$refs.enterWarehouseMultipleTable.toggleRowSelection(i, true);
          })
        } else {
          this.$nextTick(() => {
            this.$refs.enterWarehouseMultipleTable.toggleRowSelection(i, false);
          })
        }
      })
      this.initCheckedEnterWarehouseCodeList()
    },
    enterWarehouseSelectAll() {
      if (!this.enterWarehouseTableData.length) this.$refs.enterWarehouseMultipleTable.clearSelection();
    },
    // 选择进仓结算状态
    selectEnterWarehouseStatus(row, index) {
      this.activeEnterWarehouseStatusIndex = index
      this.enterWarehouseStatus = row.id
    },
    enterWarehouseCheckSelectable(row) {
      if (row.status === 2) {
        return false
      } else {
        return true
      }
    },
    // 进仓单全选
    handleEnterWarehouseCheckAllChange(val) {
      this.enterWarehouseCodeList.map(i => {
        i.checked = val
        i.subjectList.map(j => {
          if (j.status !== 2) j.isSelect = val
        })
      })
      this.checkedEnterWarehouseCodeList = val ? this.enterWarehouseCodeList : [];
      this.enterWarehouseIsIndeterminate = false;
      
      if (this.activeEnterWarehouseCode) {
        let obj = this.enterWarehouseCodeList.find(item => { return item.code === this.activeEnterWarehouseCode })
        this.enterWarehouseTableData = obj.subjectList
        this.enterWarehouseTableData.map(i => {
          if (i.isSelect) {
            this.$nextTick(() => {
              this.$refs.enterWarehouseMultipleTable.toggleRowSelection(i, true);
            })
          } else {
            this.$nextTick(() => {
              this.$refs.enterWarehouseMultipleTable.toggleRowSelection(i, false);
            })
          }
        })
      }
      this.initTotalAccountsReceivable()
    },
    /** 
     * @description 获取选中的进仓单数据
    */
    initCheckedEnterWarehouseCodeList() {
      let checkedEnterWarehouseCodeList = []
      this.enterWarehouseCodeList.map(i => {
        if (i.checked) checkedEnterWarehouseCodeList.push(i)
      })
      this.checkedEnterWarehouseCodeList = checkedEnterWarehouseCodeList
      this.enterWarehouseCheckAll = this.enterWarehouseCodeList.length === checkedEnterWarehouseCodeList.length
      this.enterWarehouseIsIndeterminate = checkedEnterWarehouseCodeList.length > 0 && checkedEnterWarehouseCodeList.length < this.enterWarehouseCodeList.length;
      this.$nextTick(() => {
        this.initTotalAccountsReceivable()
      })
    },
    /* 修改enterWarehouseCodeList里所选中的数据 */
    async handleSelectionEnterWarehouseChange(val) {
      await this.enterWarehouseCodeList.map(async j => {
        if (j.code === this.activeEnterWarehouseCode) {
          // 未结算的进仓单数量
          // let unsettledEnterWarehouseNums = 0
          // if (!val.length) j.checked = await false
          await j.subjectList.map(async c => {
            // if (c.status === 1) await unsettledEnterWarehouseNums++
            // if (val.length && val.length === unsettledEnterWarehouseNums) j.checked = await true
            c.isSelect = await false
            await val.map(async i => {
              if (c.keyId === i.keyId) {
                c.isSelect = await true
              }
            })
          })
        }
      })
      this.initCheckedEnterWarehouseCodeList()
    }
  }
}